import {watch} from 'vue';

import {candidates, is_valid, query, query_input, texts} from './models';
import {punctuations} from './punctuations';
import {keysdata, utf8data} from "./utf8data";

function resetQuery() { query_input.value = ''; }

function selectCandidate(choice: number) {
  if (choice <= candidates.value.length) {
    texts.value += candidates.value[choice - 1];
    candidates.value = []
    resetQuery();
  } else {
    is_valid.value = false;
  }
}

function decodeKeyStroke(key: string): string {
  if (!key || key.length !== 1) {
    return '?';
  }
  return String.fromCodePoint(keysdata[key]);
}

watch(query, (new_query) => {
  if (new_query.length === 0) {
    return;
  }

  // Keyboard shortcuts for punctuations
  if (new_query.length === 1 && new_query in punctuations) {
    resetQuery();
    texts.value += punctuations[new_query];
    return;
  }

  // If there are a few candidates, select one.
  const last_character = new_query[new_query.length - 1];
  if (candidates.value.length > 0) {
    const choice = parseInt(last_character);
    if (choice) {
      selectCandidate(choice);
    }
    return;
  }

  is_valid.value = true;
  if (last_character != ' ') {
    return;
  }

  const key = `_${new_query.slice(0, new_query.length - 1)}`;
  if (!(key in utf8data)) {
    is_valid.value = false;
    return;
  }

  const new_candidates = utf8data[key];
  if (new_candidates.length == 1) {
    texts.value += String.fromCodePoint(utf8data[key]);
    resetQuery();
    return;
  }

  candidates.value =
      utf8data[key].map(unicode => String.fromCodePoint(unicode));
});

export {decodeKeyStroke};